// Node
const $ = require('jquery');
import Bloodhound from 'typeahead.js/dist/bloodhound.js';
require('typeahead.js/dist/typeahead.jquery.js');
import FunnySadDialog from 'new_design/common/funny-sad-dialog';


class SearchString {
  constructor (formId, options = {}) {
    this.$form = $(`form#${formId}`);

    // Для мобильной версии при переходе на лэйаут
    this.$searchStringBase = this.$form.find(`#${options.searchStringBase}`);
    // Инпут для самого typeahead
    this.$searchString = this.$form.find(`#${options.searchString}`);
    this.$searchType = this.$form.find(`#${options.searchType}`);
    this.$searchId = this.$form.find(`#${options.searchId}`);
    this.without_submit = options.without_submit || false;
  }

  init () {
    this._eventsInit();
    this._bloodhoundInit();
  };

  open () {
    this.$searchString.typeahead('open');
    if (window.isMobileDevice) {
      this.$searchString.focus();
      this.$searchString.select();
    }
  }

  // private

  _eventsInit () {
    // При открытии простыни стирать старый поиск
    // При выборе одного из вариантов заполнять скрытые поля
    $(document)
      .on("typeahead:open", (event, data) => {
        if (window.isMobileDevice) {
          this.$searchString.focus();
          this.$searchString.select();
        } else {
          this.$searchString.select();
        }
    }).on("typeahead:select", this._onSelected);

    // При выборе варианта записываем в изначальное поле в мобильной версии
    if (window.isMobileDevice) {
      $(document).on('typeahead:asyncreceive', function(event, data) {
        $('#search_string_loader').hide();
      })
      $(document).on('typeahead:asyncrequest', function(event, data) {
        $('#search_string_loader').show();
      })
      $(document).on('typeahead:beforeclose', function(event, data) {
        event.preventDefault()
      })
      this.$searchString.on('keypress', (event) => {
        if(event.keyCode == 13) {
          if (this.without_submit) {
            this.$searchString.blur();
            this.$form.find('.tt-suggestion.tt-selectable').eq(0).click();
          } else {
            this.$form.eq(0).submit();
          }
        }
      });
      $('#search-name .search-item_cancel').click(() => {
        this.$searchString.val('');
        this.$searchString.focus();
      })
      $(document).on("typeahead:select", (event, data) => {
        this.$searchStringBase.html(this.$searchString.val());
        this.$searchStringBase.removeClass('search-params-popup__string_placeholder');
        if (this.without_submit) {
          history.back(); // Закрываем модалку
        } else {
          this.$form.eq(0).submit();
        }
      });
    }
  }

  _bloodhoundInit () {
    const camps = new Bloodhound({
      initialize: false,
      datumTokenizer(d) {
        return Bloodhound.tokenizers.whitespace(d.name);
      },

      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: `${window.website_prefix}/search/autocomplete?search=%QUERY`,
        wildcard: '%QUERY',
        transform: (objects) => {
          this._selectFirstItem(objects);
          return $.map(objects, obj => ({
            name: obj.name,
            count_camps: obj.count_camps,
            id: obj.id,
            type: obj.type,
            type_single: obj.type_single
          }));
        },
        prepare: this._prepareRequest,
        cache: false
      }
    });

    return Promise.all([
      camps.initialize,
    ]).then(() => {

      this.$searchString.typeahead({
          autoselect: window.isMobileDevice ? false : "first",
          highlight: false,
          minLength: 0
        },
        {
          limit: 'Infinity',
          name: "camps",
          templates: {
            suggestion: function (params) {
              if (params.type === 'camps') {
                return `<div class="tt-camp"><p class="tt-name">${params.name}</p></div>`;
              } else if (params.type === 'countries') {
                return `<div class="tt-country">
                        <p class="tt-name">${params.name}</p> <span class='tt-number'>${params.count_camps} вариантов</span>
                      </div>`;
              } else if (params.type === 'regions') {
                return `<div class="tt-region">
                        <p class="tt-name">${params.name}</p> <span class='tt-number'>${params.count_camps} вариантов</span>
                      </div>`;
              } else if (params.type === 'cities') {
                return `<div class="tt-city">
                        <p class="tt-name">${params.name}</p> <span class='tt-number'>${params.count_camps} вариантов</span>
                      </div>`;
              } else if (params.type === 'districts') {
                return `<div class="tt-district">
                        <p class="tt-name">${params.name}</p> <span class='tt-number'>${params.count_camps} вариантов</span>
                      </div>`;
              } else if (params.type === 'rivers') {
                return `<div class="tt-river">
                        <p class="tt-name">${params.name}</p> <span class='tt-number'>${params.count_camps} вариантов</span>
                      </div>`;
              } else if (params.type === 'area_pages') {
                return `<div class="tt-area-page">
                        <p class="tt-name">${params.name}</p> <span class='tt-number'>${params.count_camps} вариантов</span>
                      </div>`;
              }

            }
          },

          displayKey: "name",
          source: camps.ttAdapter()
        }
      );
    });
  }

  _onSelected ($e, datum) {
    document.getElementById("search_id").value = datum.id;
    document.getElementById("search_type").value = datum.type_single;
  }

  _prepareRequest (query, settings) {
    settings.url = settings.url.replace('%QUERY', encodeURIComponent(query));
    settings.error = () => {
      FunnySadDialog.createSadDialog(
        'Не удалось загрузить список объектов',
        'Проверьте работоспособность интернет-соединения или попробуйте ещё раз позднее.'
      );
    };
    return settings;
  }

  _selectFirstItem (datum) {
    if (datum.length > 0) {
      this.$searchType.val(datum[0].type_single);
      this.$searchId.val(datum[0].id);
    } else {
      document.getElementById("search_type").value = "nothing";
      this._notFound();
    }
  }

  _notFound () {
    // Открыть простыню
    this.$searchString.typeahead('open');
    // Ничего не найдено
    $(".tt-menu>.tt-dataset-camps").html(this._notFoundHtml());
  }

  _notFoundHtml () {
    return '<h3 class="tt-not-found-custom">По Вашему запросу ничего не найдено</h3>';
  }
}

export default SearchString;
